import { render, staticRenderFns } from "./OpsCard.vue?vue&type=template&id=7545cf1a&scoped=true"
import script from "./OpsCard.vue?vue&type=script&lang=js"
export * from "./OpsCard.vue?vue&type=script&lang=js"
import style0 from "./OpsCard.vue?vue&type=style&index=0&id=7545cf1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7545cf1a",
  null
  
)

export default component.exports